<script setup lang="ts">
import DashboardNavButton from "@/components/navigation/DashboardNavButton.vue";
import IntegrityNavButton from "@/components/navigation/IntegrityNavButton.vue";
import MapNavButton from "@/components/navigation/MapNavButton.vue";
import SettingNavButton from "@/components/navigation/SettingNavButton.vue";
import { Site, Station } from "@soft-db/monitoring-api-client";

type Page = "map" | "dashboard" | "integrity" | "settings";

const props = defineProps({
	site: {
		type: Object as PropType<Site>,
		required: false,
	},
	station: {
		type: Object as PropType<Station>,
		required: false,
	},
	page: String as PropType<Page | undefined>,
});

const siteId = computed(() => props.site?.id || props.station?.site?.id);

const sourceType = computed(() => (props.station != null ? "station" : "site"));
const sourceId = computed(() => props.station?.id ?? props.site?.id ?? "");

const inFavorite = computed(() => {
	if (props.site != null) {
		return props.site.inFavorite;
	} else if (props.station != null) {
		return props.station?.inFavorite;
	}

	return true;
});

const links = computed<Page[]>(() => {
	return ["map", "dashboard", "integrity", "settings"];
});
</script>

<template>
	<div class="flex flex-row items-center justify-around px-2">
		<template v-for="link of links" :key="link">
			<MapNavButton
				v-if="link === 'map'"
				:sourceType="sourceType"
				:sourceId="sourceId"
				:inFavorite="inFavorite"
				:disabled="page === link"
				ghost
			/>
			<DashboardNavButton
				v-else-if="link === 'dashboard' && site != null"
				:siteId="siteId"
				:disabled="page === link"
				ghost
			/>
			<IntegrityNavButton
				v-else-if="link === 'integrity'"
				:sourceType="sourceType"
				:sourceId="sourceId"
				:disabled="page === link"
				ghost
			/>
			<SettingNavButton
				v-else-if="link === 'settings'"
				:sourceType="sourceType"
				:sourceId="sourceId"
				:disabled="page === link"
				ghost
			/>
		</template>
	</div>
</template>
